export function runBotDetection() {
  var documentDetectionKeys = [
    '__webdriver_evaluate',
    '__selenium_evaluate',
    '__webdriver_script_function',
    '__webdriver_script_func',
    '__webdriver_script_fn',
    '__fxdriver_evaluate',
    '__driver_unwrapped',
    '__webdriver_unwrapped',
    '__driver_evaluate',
    '__selenium_unwrapped',
    '__fxdriver_unwrapped',
  ];

  var windowDetectionKeys = [
    '_phantom',
    '__nightmare',
    '_selenium',
    'callPhantom',
    'callSelenium',
    '_Selenium_IDE_Recorder',
  ];

  for (const windowDetectionKey in windowDetectionKeys) {
    const windowDetectionKeyValue = windowDetectionKeys[windowDetectionKey];
    if (window[windowDetectionKeyValue]) {
      return 'BOT DETECTED: ' + windowDetectionKeyValue;
    }
  }
  for (const documentDetectionKey in documentDetectionKeys) {
    const documentDetectionKeyValue =
      documentDetectionKeys[documentDetectionKey];
    if (window['document'][documentDetectionKeyValue]) {
      return 'BOT DETECTED: ' + documentDetectionKeyValue;
    }
  }

  for (const documentKey in window['document']) {
    if (
      documentKey.match(/\$[a-z]dc_/) &&
      window['document'][documentKey]['cache_']
    ) {
      return 'BOT DETECTED: ' + documentKey;
    }
  }

  if (
    window['external'] &&
    window['external'].toString() &&
    window['external'].toString()['indexOf']('Sequentum') != -1
  )
    return 'BOT DETECTED: Sequentum';

  if (window['document']['documentElement']['getAttribute']('selenium'))
    return 'BOT DETECTED: selenium';
  if (window['document']['documentElement']['getAttribute']('webdriver'))
    return 'BOT DETECTED: webdriver';
  if (window['document']['documentElement']['getAttribute']('driver'))
    return 'BOT DETECTED: driver';

  return false;
}
